import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {User} from './User';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticationService {
    constructor(private httpClient: HttpClient) { }
    private user:User;
    private url: string = 'https://api.on-track.in/api/';
    private posturl1='https://api.on-track.in/api/authenticate';
    username:string;
    password:string;

     login({ value, valid}: { value: User, valid: boolean }) : Observable<any>{
        this.user = value;
        console.log( this.user);
        console.log("valid: " + valid);
        
        //let jsonData = {this.username=value.username,password=this.password};
        return this.httpClient.post(this.posturl1 ,this.user)
        //return this.httpClient.get(geturl, {})
        
            .map(
            (res: Response) => {
              if (res.json().status == true) {
                localStorage.setItem('currentUser', JSON.stringify(res.json().data));
                
                console.log("Hello");
                
              }
              return res.json();
            },
            err => {
              return err;
            }
            )
        
       
      }
      
      logout() {
        localStorage.removeItem('currentUser');
      }
      getItem(): Observable<any> {
        const getItemUrl = this.url + 'customer';
        return this.httpClient.get(getItemUrl, {})
          .map(
            (res: Response) => {
            return res.json();
          },
          err => {
            return err;
          }
          )
      }
      
}


// WEBPACK FOOTER //
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/app/authentication.service.ts